import { Component } from '@angular/core';
import { MealMemberBasicDetailsComponent } from '../../meal-plan/meal-member-basic-details/meal-member-basic-details.component';
import { MealPlanService } from '../../meal-plan/meal-plan.service';
import { MealPlanServiceV2 } from '../meal-plan-v2.service';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { NgFor } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDateRangeInput } from '@angular/material/datepicker';
import { MatLabel } from '@angular/material/form-field';
import { MatHint } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { ToastService } from '../../services/toast.service';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { SharedServiceService } from '../../services/shared-service.service';
import {
  formatDate
}
  from '@angular/common';
import { PreferenceComponent } from '../../meal-plan/preference/preference.component';
import { NgIf } from '@angular/common';
import { Router } from "@angular/router";

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
declare var $: any;

@Component({
  selector: 'app-create-plan',
  standalone: true,
  imports: [NgxMaterialTimepickerModule, MatProgressSpinnerModule, NgIf, PreferenceComponent, MealMemberBasicDetailsComponent, FormsModule, NgClass, NgFor, MatDateRangeInput, MatDatepickerModule, MatFormFieldModule, MatLabel, MatHint, MatNativeDateModule, MatInputModule],
  templateUrl: './create-plan.component.html',
  styleUrl: './create-plan.component.css'
})

export class CreatePlanComponentV2 {
  target: any = [];
  dailyTarget: any;
  // original total calories before deficit
  totalCaloriesNeeded: any;
  proteinGoal: number | null = null;
  carbsGoal: number | null = null;
  fatsGoal: number | null = null;
  allPrefer: any = {};
  memberId: any;
  userLoggedIn: any = '';
  deficit: any;
  allDates: any = [];
  meal: any = [];
  createMeal: any = [];
  mealResult: any = [];
  iscreateMeal: boolean = true;
  isEarlyMorning: any = 1;
  isBreakfast: any = 1;
  isMidMorning: any = 1;
  isLunch: any = 1;
  isMidEvening: any = 1;
  isDinner: any = 1;
  isBedtime: any = 1;
  isSnack: any = 1;
  mealPlanName: any = '';
  isEarlyMorningCross: any = 1;
  isBreakCross: any = 1;
  isMidMorningCross: any = 1;
  isLunchCross: any = 1;
  isMidEveningCross: any = 1;
  isDinnerCross: any = 1;
  isBedtimeCross: any = 1;
  isSnackCross: any = 1;
  isCuisineDefault: any = 1;
  // New fields for north-star custom inputs
  modificationPercentage: any = '';
  modificationMealsAllowed: string = ''; // comma separated
  explorationPercentage: any = '';
  explorationMealsAllowed: string = '';
  plasticWrapperPercentage: any = '';
  plasticWrapperMealsAllowed: string = '';
  memberDetails: any = [];
  backType = 1;
  isSingle: boolean = false;
  isLoading: any = 2;
  todayDate: Date = new Date();
  checkSelectedMealType: any = [0, 1, 1, 1, 1, 1, 1, 1, 1];
  actualWeight: any = 0;
  instructions:any = '';
  constructor(private mealService: MealPlanService, private mealServiceV2: MealPlanServiceV2, private route: ActivatedRoute,
     private router: Router, private toast: ToastService,private SharedService:SharedServiceService) {}

  ngOnInit(): void {
    this.memberId = this.route.snapshot.queryParamMap.get('memberId');
    this.getTarget();

    this.SharedService.checkLogin().subscribe({
      next: (isLoggedIn: boolean) => {
        let user = this.SharedService.getLoggedInUser();
        this.userLoggedIn = user.id;
        console.log('User logged in:', this.userLoggedIn);
      },
      error: (error) => {
        console.error('Error occurred during login check:', error);
      }
    }); 
  }

  getTarget() {
    this.mealService.getDailyTarget(this.memberId).subscribe(response => {
      this.target = response;
      const memberTarget = this.target?.memberTarget ?? {};

      // Fill macro goals from API when it succeeds (user can still edit them)
      this.proteinGoal = this.toNullableNumber(memberTarget.proteinGoal);
      this.carbsGoal = this.toNullableNumber(memberTarget.carbsGoal);
      this.fatsGoal = this.toNullableNumber(memberTarget.fatsGoal);

      // Daily Target Calories: only from macro goals (not from API). Deficit is independent and does not change dailyTarget.
      const deficitRaw = memberTarget.caloriesDeficitGoal;
      this.deficit = deficitRaw === null || deficitRaw === undefined || deficitRaw === '' ? 0 : Number(deficitRaw);
      if (!Number.isFinite(Number(this.deficit))) {
        this.deficit = 0;
      }
      this.recalculateDailyTarget();
      this.getPreference();
    });
  }

  private toNullableNumber(val: any): number | null {
    if (val === null || val === undefined || val === '') return null;
    const n = Number(val);
    return Number.isFinite(n) ? n : null;
  }

  private roundToNearestInt(val: any): number {
    const n = Number(val);
    if (!Number.isFinite(n)) return 0;
    return Math.round(n);
  }

  recalculateDailyTarget(): void {
    const protein = Number(this.proteinGoal) || 0;
    const carbs = Number(this.carbsGoal) || 0;
    const fats = Number(this.fatsGoal) || 0;
    // Daily Target Calories = protein*4 + carbs*4 + fats*9
    this.dailyTarget = (protein * 4) + (carbs * 4) + (fats * 9);
    // keep original total calories for any downstream usage
    this.totalCaloriesNeeded = this.dailyTarget;
    // Update meal allocations whenever dailyTarget changes
    this.changeDailyTarget();
  }

  getPreference() {

    this.mealService.getPreference(this.memberId).subscribe(response => {

      // keep full API response so we don't lose helper fields like defaultTimingForMeal
      const apiPreference: any = response;
      this.allPrefer = apiPreference;
      let prepTimes = [30, 20, 10, 20];

      if (this.allPrefer.preferences !== undefined) {
        //  console.log('here',this.allPrefer.preferences);
        // merge core preferences while preserving top-level helpers like defaultTimingForMeal
        const corePrefs = this.allPrefer.preferences || {};
        this.allPrefer = {
          ...corePrefs,
          defaultTimingForMeal: apiPreference.defaultTimingForMeal || []
        };
        // ensure new meal-type ingredient arrays exist
        const ensureArray = (obj: any, key: string) => {
          if (!obj[key]) {
            obj[key] = [];
          }
        };
        const liked = this.allPrefer.likedIngredients || {};
        const disliked = this.allPrefer.dislikedIngredients || {};
        ['earlymorning', 'breakfast', 'midmorning', 'lunch', 'midevening', 'snack', 'dinner', 'bedtime'].forEach(k => {
          ensureArray(liked, k);
          ensureArray(disliked, k);
        });
        this.allPrefer.likedIngredients = liked;
        this.allPrefer.dislikedIngredients = disliked;

        prepTimes = [this.allPrefer.lifeStyle.bPrepTime, this.allPrefer.lifeStyle.lPrepTime, this.allPrefer.lifeStyle.dPrepTime, this.allPrefer.lifeStyle.sPrepTime];
      } else {
        // console.log('sec');
        this.allPrefer = {
          id: '',
          memberId: this.memberId,
          cuisine: {
            defaultCuisines: [],
            likedCuisines: [],
            dislikedCuisines: [],
            foodRestrictions: [],
          },
          allergies: [],
          likedIngredients: {
            "earlymorning": [],
            "breakfast": [],
            "midmorning": [],
            "lunch": [],
            "midevening": [],
            "snack": [],
            "dinner": [],
            "bedtime": []
          },
          dislikedIngredients: {
            "earlymorning": [],
            "breakfast": [],
            "midmorning": [],
            "lunch": [],
            "midevening": [],
            "snack": [],
            "dinner": [],
            "bedtime": []
          },
          lifeStyle: {
            emPrepTime: 0,
            bPrepTime: 0,
            mmPrepTime: 0,
            lPrepTime: 0,
            mePrepTime: 0,
            sPrepTime: 0,
            dPrepTime: 0,
            btPrepTime: 0,
            isKidFriendly: true,
            isMealPlanningFriendly: true
          }
        };
      }

      let type = ['Early morning', 'Breakfast', 'Mid morning', 'Lunch', 'Mid evening', 'Snack', 'Dinner', 'Bedtime'];
      // initialize default percentages as numbers so bindings update correctly
      let percentage = ['5', '30', '5', '30', '5', '5', '15', '5'];

      for (let i = 0; i < 8; i++) {
        const pct = percentage[i];
        const mealType = type[i];
        // pre-fill meal time from preferences.defaultTimingForMeal, if available
        const defaultTime = this.getDefaultTimeForMealType(mealType);
        this.meal.push({
          percentage: pct,
          type: mealType,
          calories: this.getCal(pct),
          macroBreakdown: { protein: 50, carbs: 30, fat: 20 },
          prepTime: prepTimes[i] || 15,
          time: defaultTime
        });
      }
      //console.log(this.meal);
    });


  }

  // helper to safely read default time for a given meal type from preferences API
  getDefaultTimeForMealType(mealType: string): string {
    if (!this.allPrefer || !Array.isArray(this.allPrefer.defaultTimingForMeal)) {
      return '';
    }
    const found = this.allPrefer.defaultTimingForMeal.find((x: any) => x && x.mealType === mealType);
    return found && found.time ? found.time : '';
  }

  getCal(percentage: any) {
    // Meal split uses Daily Target Calories only; Calorie Deficit Goal does not change this.
    const val = Number(this.dailyTarget) || 0;
    return (val * Number(percentage)) / 100;
  }

  changeDailyTarget() {
    for (let i = 0; i < this.meal.length; i++) {
      this.meal[i].calories = this.getCal(this.meal[i].percentage);
    }
  }

  createMealPlan(isNewMealPlan:any) {
    //console.log('sdd');
    if (this.allDates.length < 1) {
      this.toast.errorMessage('Please choose the dates.');
    } else {
      let fromDate = formatDate(this.allDates[0].planStartDate, 'yyyy-MM-dd', 'en');
      let toDate = formatDate(this.allDates[0].planEndDate, 'yyyy-MM-dd', 'en');
      const timeVal = this.meal.filter((x: any) => x.time == '');
      // console.log(this.meal);
      // console.log(timeVal.length);
  
      if (this.dailyTarget < 1) {
        this.toast.errorMessage('Daily target calories must be greater than 0.');
      }
      else if (this.checkSelectedMealType[1] == 2 && this.checkSelectedMealType[2] == 2 && this.checkSelectedMealType[3] == 2 && this.checkSelectedMealType[4] == 2 && this.checkSelectedMealType[5] == 2 && this.checkSelectedMealType[6] == 2 && this.checkSelectedMealType[7] == 2 && this.checkSelectedMealType[8] == 2) {
        this.toast.errorMessage('Please add atleast one meal.');
      }
      else if (timeVal.length > 0) {
        this.toast.errorMessage('Please add the meal time.');
      }else if(this.mealPlanName.trim() === ''){
        this.toast.errorMessage('Please enter the meal plan name.');
      } 
      else if (fromDate <= toDate) {
        // parse meals allowed fields into arrays
        const parseMeals = (s: string) => {
          if (!s) return [];
          return s.split(',').map((x: string) => x.trim()).filter((x: string) => x.length > 0);
        };

        // build a clean payload: ensure types/format match API expectations
        const mealsPayload = this.meal.map((m: any) => ({
          percentage: String(m.percentage),
          type: m.type,
          calories: String(Number(m.calories)),
          macroBreakdown: m.macroBreakdown,
          prepTime: m.prepTime,
          time: m.time || ''
        }));

        this.createMeal = {
          // keep both keys for backward compatibility; use totalCaloriesNeeded and explicit deficit
          calsNeeded: String(this.roundToNearestInt(this.dailyTarget)),
          caloriesDeficitGoal: this.roundToNearestInt(this.deficit),
          // Send member macro goals to chat API (grams)
          carbsGoal: this.roundToNearestInt(this.carbsGoal),
          proteinGoal: this.roundToNearestInt(this.proteinGoal),
          fatsGoal: this.roundToNearestInt(this.fatsGoal),
          planStartDate: this.dateFormat(this.allDates[0].planStartDate),
          planEndDate: this.dateFormat(this.allDates[0].planEndDate),
          actualEndDate: this.dateFormat(this.allDates[0].orignialEndDate),
          meals: mealsPayload,
          cuisinePreference: {
            default: this.allPrefer.cuisine.defaultCuisines,
            liked: this.allPrefer.cuisine.likedCuisines,
            disliked: this.allPrefer.cuisine.dislikedCuisines,
            foodRestrictions: this.allPrefer.cuisine.foodRestrictions
          },
          allergies: this.allPrefer.allergies,
          ingredientPreferences: { liked: this.allPrefer.likedIngredients, disliked: this.allPrefer.dislikedIngredients },
          lifeStyle: { isKidFriendly: this.allPrefer.lifeStyle.isKidFriendly, isMealPlanningFriendly: this.allPrefer.lifeStyle.isMealPlanningFriendly },
          memberId: this.memberId,
          userId: this.userLoggedIn,
          planName: this.mealPlanName.trim(),
          instructions: this.instructions.trim().replace(/\n/g, ' '),
          northStarInputs: {
            modificationPercentage: this.modificationPercentage,
            modificationMealsAllowed: parseMeals(this.modificationMealsAllowed),
            explorationPercentage: this.explorationPercentage,
            explorationMealsAllowed: parseMeals(this.explorationMealsAllowed),
            plasticWrapperPercentage: this.plasticWrapperPercentage,
            plasticWrapperMealsAllowed: parseMeals(this.plasticWrapperMealsAllowed)
          }
        };
        this.mealService.addPreference(this.allPrefer).subscribe(response => {

        });
       
  // debug: dump payload so QA can inspect outgoing request
  console.log('mealplan_v2 payload:', JSON.stringify(this.createMeal));
  this.isLoading = 1;
  this.mealServiceV2.createMealPlan(this.createMeal, isNewMealPlan).subscribe(response => {
          this.isLoading = 2;
          // console.log(response);
          if (response === 1) {
            this.toast.errorMessage('Request Timed out. Please try again.');
          } else if (response === 2){
            this.toast.errorMessage('Api through error. Please try again.');
          } else {
            // this.mealResult = response;
            // this.mealResult = this.mealResult.meals;
            // this.iscreateMeal = false;
            this.backType = 2;
            //  this.ToastrService.success('Meals fetch successfully.');
            // this.toast.successMessage('Meals fetch successfully.');
            $('#createConfirm').modal('show');
          }


        });

      } else {
        //  this.ToastrService.error('To date always above from date.');
        //console.log('To date always above from date.');

        //console.log('Duplicate Time Exist');
        this.toast.errorMessage('To date always above from date.');

      }
    }
  }

  calculateDiff(start: any, end: any) {

    var date1: any = new Date(start);
    var date2: any = new Date(end);
    var diffDays: any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));

    return diffDays;
  }

  getSelectedDate(startDt: HTMLInputElement, endDt: HTMLInputElement) {
    this.allDates = [];
    if (startDt.value != '' && endDt.value != '') {
      let diff = this.calculateDiff(startDt.value, endDt.value) + 1;
      let newDt: any = endDt.value;
      let dt = new Date(startDt.value);
      if (diff > 7) {
        dt.setDate(dt.getDate() + 6);
        newDt = this.dateFormat(dt);
      }
      this.allDates.push({ planStartDate: startDt.value, planEndDate: newDt, orignialEndDate: endDt.value });
    }
  }

  dateFormat(date: any) {
    return formatDate(date, 'yyyy-MM-dd', 'en-US');
  }

  removeMealType(type: any, index: any) {
    this.checkSelectedMealType[type] = 2;
    // console.log( this.checkSelectedMealType);
    this.showHideMeal(type, 2, index);
  }

  addMealType(type: any, index: any) {
    this.checkSelectedMealType[type] = 1;
    this.showHideMeal(type, 1, index);
  }

  showHideMeal(type: any, val: any, index: any) {
    if (type == 1) {
      this.isEarlyMorning = val;
      this.isEarlyMorningCross = val;
    }
    else if (type == 2) {
      this.isBreakfast = val;
      this.isBreakCross = val;
    }
    else if (type == 3) {
      this.isMidMorning = val;
      this.isMidMorningCross = val;
    }
    else if (type == 4) {
      this.isLunch = val;
      this.isLunchCross = val;
    }
    else if (type == 5) {
      this.isMidEvening = val;
      this.isMidEveningCross = val;
    }
    else if (type == 6) {
      this.isDinner = val;
      this.isDinnerCross = val;
    }
    else if (type == 7) {
      this.isBedtime = val;
      this.isBedtimeCross = val;
    }
    else if (type == 8) {
      this.isSnack = val;
      this.isSnackCross = val;
    }


    let type1 = ['Early morning', 'Breakfast', 'Mid morning', 'Lunch', 'Mid evening', 'Snack', 'Dinner', 'Bedtime'];
    let percentage = ['5', '30', '5', '30', '5', '5', '15', '5'];
    let prepTimes = [
      this.allPrefer.lifeStyle?.emPrepTime || 15,
      this.allPrefer.lifeStyle?.bPrepTime || 30,
      this.allPrefer.lifeStyle?.mmPrepTime || 15,
      this.allPrefer.lifeStyle?.lPrepTime || 20,
      this.allPrefer.lifeStyle?.mePrepTime || 15,
      this.allPrefer.lifeStyle?.sPrepTime || 20,
      this.allPrefer.lifeStyle?.dPrepTime || 10,
      this.allPrefer.lifeStyle?.btPrepTime || 15
    ];
    this.meal = [];
    for (let i = 0; i < 8; i++) {
      if (this.isEarlyMorning == 1 && i == 0) {
        this.meal.push({
          percentage: percentage[i],
          type: type1[i],
          calories: this.getCal(percentage[i]),
          macroBreakdown: { protein: 50, carbs: 30, fat: 20 },
          prepTime: prepTimes[i],
          time: this.getDefaultTimeForMealType(type1[i])
        });
      }
      else if (this.isBreakfast == 1 && i == 1) {
        this.meal.push({
          percentage: percentage[i],
          type: type1[i],
          calories: this.getCal(percentage[i]),
          macroBreakdown: { protein: 50, carbs: 30, fat: 20 },
          prepTime: prepTimes[i],
          time: this.getDefaultTimeForMealType(type1[i])
        });
      }
      else if (this.isMidMorning == 1 && i == 2) {
        this.meal.push({
          percentage: percentage[i],
          type: type1[i],
          calories: this.getCal(percentage[i]),
          macroBreakdown: { protein: 50, carbs: 30, fat: 20 },
          prepTime: prepTimes[i],
          time: this.getDefaultTimeForMealType(type1[i])
        });
      }
      else if (this.isLunch == 1 && i == 3) {
        this.meal.push({
          percentage: percentage[i],
          type: type1[i],
          calories: this.getCal(percentage[i]),
          macroBreakdown: { protein: 50, carbs: 30, fat: 20 },
          prepTime: prepTimes[i],
          time: this.getDefaultTimeForMealType(type1[i])
        });
      }
      else if (this.isMidEvening == 1 && i == 4) {
        this.meal.push({
          percentage: percentage[i],
          type: type1[i],
          calories: this.getCal(percentage[i]),
          macroBreakdown: { protein: 50, carbs: 30, fat: 20 },
          prepTime: prepTimes[i],
          time: this.getDefaultTimeForMealType(type1[i])
        });
      }
      else if (this.isSnack == 1 && i == 5) {
        this.meal.push({
          percentage: percentage[i],
          type: type1[i],
          calories: this.getCal(percentage[i]),
          macroBreakdown: { protein: 50, carbs: 30, fat: 20 },
          prepTime: prepTimes[i],
          time: this.getDefaultTimeForMealType(type1[i])
        });
      }
      else if (this.isDinner == 1 && i == 6) {
        this.meal.push({
          percentage: percentage[i],
          type: type1[i],
          calories: this.getCal(percentage[i]),
          macroBreakdown: { protein: 50, carbs: 30, fat: 20 },
          prepTime: prepTimes[i],
          time: this.getDefaultTimeForMealType(type1[i])
        });
      }
      else if (this.isBedtime == 1 && i == 7) {
        this.meal.push({
          percentage: percentage[i],
          type: type1[i],
          calories: this.getCal(percentage[i]),
          macroBreakdown: { protein: 50, carbs: 30, fat: 20 },
          prepTime: prepTimes[i],
          time: this.getDefaultTimeForMealType(type1[i])
        });
      }
    }
  }

  backButton(type: any) {
    if (type == 1) {
      this.router.navigate(['/meal-plans']);
    }
    if (type == 2) {
      this.iscreateMeal = true;
      this.backType = 1;
    }
    else if (type == 3) {
      this.isSingle = false;
    }

  }

  mealDetailBack(type: any) {
    this.backType = parseInt(type);
    //console.log(this.backType);
  }

  checkTime(data: any, index: any) {
    if (data.target.value != '') {
      const timeVal = this.meal.filter((x: any) => x.time == data.target.value);
      if (timeVal.length > 1) {
        //console.log('Duplicate Time Exist');
        this.toast.errorMessage('Duplicate time exist.');
        this.meal[index].time = '';
      }
    }
    //console.log(this.meal);
  }
  continueClick(){
    this.router.navigate(['/v2/all-meals'], {
      queryParams: {
        memberId: this.memberId,
        isType: 4
      }
    });
  }
}